import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import service from '../../Service/Service';
import { CheckCircle } from 'lucide-react';
import { formatCurrency } from '../../utils/currencyConverter';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState(null);

    useEffect(() => {
        // Get payment details from URL params
        const orderId = searchParams.get('orderId') || searchParams.get('orderID');
        const sessionId = searchParams.get('sessionId') || searchParams.get('sessionID');
        
        console.log('Payment success page loaded:', { orderId, sessionId });
        
        // Extract all payment data from URL
        const allParams = {};
        for (let [key, value] of searchParams.entries()) {
            allParams[key] = value;
        }
        
        setPaymentData(allParams);
        setLoading(false);
    }, [searchParams]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg">
                {!loading && (
                    <>
                        <div className="text-center">
                            <CheckCircle className="mx-auto h-16 w-16 text-green-500" />
                            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                                Payment Successful!
                            </h2>
                            <p className="mt-2 text-sm text-gray-600">
                                Your booking has been confirmed and payment received.
                            </p>
                        </div>

                        {paymentData && (
                            <div className="mt-8 border-t border-gray-200 pt-6">
                                <dl className="space-y-4">
                                    {paymentData.orderID && (
                                        <div>
                                            <dt className="text-sm font-medium text-gray-500">Order ID</dt>
                                            <dd className="mt-1 text-sm text-gray-900">{paymentData.orderID}</dd>
                                        </div>
                                    )}
                                    {paymentData.purchaseAmount && (
                                        <div>
                                            <dt className="text-sm font-medium text-gray-500">Amount Paid</dt>
                                            <dd className="mt-1 text-sm text-gray-900">
                                                {formatCurrency(Number(paymentData.purchaseAmount), paymentData.currency || 'GBP')}
                                            </dd>
                                        </div>
                                    )}
                                    {paymentData.tranDateTime && (
                                        <div>
                                            <dt className="text-sm font-medium text-gray-500">Transaction Date</dt>
                                            <dd className="mt-1 text-sm text-gray-900">{paymentData.tranDateTime}</dd>
                                        </div>
                                    )}
                                    {paymentData.approvalCode && (
                                        <div>
                                            <dt className="text-sm font-medium text-gray-500">Approval Code</dt>
                                            <dd className="mt-1 text-sm text-gray-900">{paymentData.approvalCode}</dd>
                                        </div>
                                    )}
                                </dl>
                            </div>
                        )}

                        <div className="mt-8 space-y-3">
                            <p className="text-sm text-gray-600 text-center">
                                You will receive a confirmation email shortly with your booking details.
                                Our team will contact you within 24 hours to finalize your travel arrangements.
                            </p>
                            <div className="text-center">
                                <p className="text-sm font-semibold text-gray-900">
                                    For immediate assistance, call:
                                </p>
                                <p className="text-lg font-bold text-secondary">
                                    03338820922
                                </p>
                            </div>
                        </div>

                        <div className="mt-8">
                            <button
                                onClick={() => navigate('/')}
                                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-secondary hover:bg-navy-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                            >
                                Return to Home
                            </button>
                        </div>
                    </>
                )}

                {loading && (
                    <div className="text-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary mx-auto"></div>
                        <p className="mt-4 text-gray-600">Processing payment confirmation...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccess;
